/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';

function ReportConfigPrototype(reportId, reportName, embedUrl, datasetId) {
  this.reportId = reportId;
  this.reportName = reportName;
  this.embedUrl = embedUrl;
  this.datasetId = datasetId;
}

export class PowerBiParams extends DaoModel {
  constructor(tokenId, accessToken, tokenExpiry, reportConfig) {
    super();
    this.tokenId = tokenId;
    this.accessToken = accessToken;
    this.tokenExpiry = tokenExpiry;
    this.reportConfig = reportConfig;
  }

  static toInstance(props = {}) {
    const reportConfig = new ReportConfigPrototype(props.reportConfig[0].reportId, props.reportConfig[0].reportName,
      props.reportConfig[0].embedUrl, props.reportConfig[0].datasetId);
    return new PowerBiParams(props.tokenId, props.accessToken, props.tokenExpiry, reportConfig);
  }

  serialize() {
    return {
      ...super.serialize(),
    };
  }
}
